import { Text } from '@mantine/core'
import { naira } from '../../utils/format'

/** Money in naira from integer kobo, tabular numerals. Large figures use the heading face. */
export default function Money({ kobo, size = 'md', fw = 500, heading = false, c }) {
  return (
    <Text className="num" size={size} fw={fw} c={c} ff={heading ? 'var(--mantine-font-family-headings)' : undefined} component="span">
      {naira(kobo)}
    </Text>
  )
}
